import { Utensils, Martini, Beer, Music, PartyPopper, Wine, MapPin } from "lucide-react";

const ICONS = {
  utensils: Utensils,
  martini: Martini,
  beer: Beer,
  music: Music,
  party: PartyPopper,
  wine: Wine,
  "map-pin": MapPin,
};

export function CategoryIcon({ name, ...props }) {
  const Icon = ICONS[name] || MapPin;
  return <Icon {...props} />;
}
